import { render } from "./TimerComponent.vue?vue&type=template&id=94571254"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/TimerComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94571254"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94571254', __exports__)) {
    console.log('reload')
    api.reload('94571254', __exports__)
  }
  
  module.hot.accept("./TimerComponent.vue?vue&type=template&id=94571254", () => {
    console.log('re-render')
    api.rerender('94571254', render)
  })

}


export default __exports__